
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

export default {
components: {
Grid,
GridItem,
GroupTitle,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem
},
methods: {
},
data () {
return {
GridData: [
{text: '监管证件', link: '/RegulatoryDoc', icon: '监管证件.png'},
{text: '监管方式', link: '/SuperviseTools', icon: '监管方式.png'},
{text: '关区', link: '/Customs', icon: '关区.png'},
{text: '结汇方式', link: '/ExchangeSettlement', icon: '结汇方式.png'},
{text: '国别(地区)', link: '/Country', icon: '国家(地区).png'},
{text: '用途', link: '/UseTo', icon: '用途.png'},
{text: '货币', link: '/Currency', icon: '货币.png'},
{text: '成交方式', link: '/TransactionMethod', icon: '成交方式.png'},
{text: '计量单位', link: '/Units', icon: '计量单位.png'},
{text: '国内地区', link: '/locationArea', icon: '国内地区.png'},
{text: 'UN编码', link: '/PUNCode', icon: '信息产品.png'},
{text: '企业性质', link: '/CompanyNature', icon: '企业性质.png'},
{text: '征免性质', link: '/ExemptionNature', icon: '征免性质.png'},
{text: '征减免税', link: '/ExemptionReliefWay', icon: '征减免税.png'},
{text: '运输方式', link: '/ShappingMode', icon: '运输方式.png'},
{text: '关联理由', link: '/PRelatedReasons', icon: '关联理由.png'},
{text: '集装箱规格', link: '/PContainerModels', icon: '集装箱规格.png'},
{text: '危包规格', link: '/PDangerousGoods', icon: '危包规格.png'},
{text: '国内口岸', link: '/PDomesticPorts', icon: '国内口岸.png'},
{text: '货物属性', link: '/PGoodsProperty', icon: '货物属性.png'},
{text: '原产地区', link: '/POriginCountry', icon: '原产地区.png'},
{text: '包装种类', link: '/PPackingType', icon: '包装种类.png'},
{text: '港口代码', link: '/PPortType', icon: '港口代码.png'},
{text: '随附单据', link: '/PInvoices', icon: '通关指南.png'},
{text: '企业产品许可', link: '/PPermitType', icon: '企业产品许可.png'}

]
}
},
created: function () {




}
}



// WEBPACK FOOTER //
// ./src/components/PassEntryParam.vue